const ChannelIcons = {
  email: "fas fa-envelope",
  hue: "fas fa-lightbulb",
  slack: "fab fa-slack",
  push: "fas fa-mobile-alt",
  default: "fas fa-bell"
};

export default ChannelIcons;